import { render, staticRenderFns } from "./SubmitAppForm.vue?vue&type=template&id=224af874"
import script from "./SubmitAppForm.vue?vue&type=script&lang=js"
export * from "./SubmitAppForm.vue?vue&type=script&lang=js"
import style0 from "./SubmitAppForm.vue?vue&type=style&index=0&id=224af874&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports